import { faker } from '@faker-js/faker'

import { TreatmentTime, TreatmentTimeUnit } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getTreatmentTime = asBuilder((): TreatmentTime => {
  return {
    type: faker.helpers.enumValue(TreatmentTimeUnit),
    value: faker.number.int(),
  }
})
